import { CENTS_IN_DOLLAR } from '@app/constants';
import { ModelMixin } from '@app/models/core/base-generic.model';

export class ProductPlan extends ModelMixin<ProductPlan, string>() {
    protected static _resource = 'billingProducts/:billingProduct/billingProductPlans';

    protected static _version = 'v2';

    get quantity(): number {
        return this._attributes['quantity'];
    }

    get product(): string {
        return this._attributes['product'];
    }

    get active(): boolean {
        return this._attributes['active'];
    }

    get amount(): number {
        return +this._attributes['amount'] / CENTS_IN_DOLLAR;
    }

    get interval(): string {
        return this._attributes['interval'];
    }

    get billingScheme(): 'tiered' | 'per_unit' {
        return this._attributes['billingScheme'];
    }

    get tiers(): StripeTier[] {
        return this._attributes['tiers'];
    }
}

export type StripeTier = {
    flatAmount: number | null;
    amount: number | null;
    upTo: number | null;
};
